import { render, staticRenderFns } from "./json_editor.vue?vue&type=template&id=20bae838"
import script from "./json_editor.vue?vue&type=script&lang=js"
export * from "./json_editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports